module.exports = __webpack_public_path__ + "img/background.cc2205e9.png";